import { type MouseEvent, useCallback, useContext } from "react";

import { type ContextMenuPayload } from "../model/types/contextMenu";
import { Context } from "./Context";

export const useContextMenu = (contextId: string): ContextMenuPayload => {
  const { objects, showById, hideById } = useContext(Context);

  const showContextMenu = useCallback(
    (focusedId: string, e: MouseEvent) => {
      e.preventDefault();

      showById(contextId, { focusedId, coords: { clientX: e.clientX, clientY: e.clientY } });
    },
    [contextId, showById]
  );

  const hideContextMenu = useCallback(() => {
    hideById(contextId);
  }, [contextId, hideById]);

  return {
    contextId,
    focusedItem: objects.get(contextId)?.focusedId,
    showContextMenu,
    hideContextMenu,
  };
};
